module.exports = __webpack_public_path__ + "img/dd-dice-1.bdbd6374.png";